import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { FlagBadge, FlagBadgeStyle } from './FlagBadge';
import { _js } from '@ifixit/utils/localize';

type DifficultyTheming = {
   icon: string;
} & FlagBadgeStyle;

export enum GuideDifficulty {
   VeryEasy = 1,
   Easy = 2,
   Moderate = 3,
   Difficult = 4,
   VeryDifficult = 5,
}

export const DifficultyToolTipLookup: { [_key in GuideDifficulty]: string } = {
   [GuideDifficulty.VeryEasy]: _js('Difficulty rating: Very easy! No disassembly required.'),
   [GuideDifficulty.Easy]: _js(
      'Difficulty rating: Easy! Minimal disassembly, using only basic tools.'
   ),
   [GuideDifficulty.Moderate]: _js(
      'Difficulty rating: Moderate. Follow instructions carefully to succeed.'
   ),
   [GuideDifficulty.Difficult]: _js(
      'Difficulty rating: Difficult. Proceed with caution and patience.'
   ),
   [GuideDifficulty.VeryDifficult]: _js(
      'Difficulty rating: Very. Bring your best skills and tools.'
   ),
};

const DifficultyThemeLookup: { [_key in GuideDifficulty]: DifficultyTheming } = {
   [GuideDifficulty.VeryDifficult]: {
      icon: 'gauge-max',
      badgeClass: 'bg-red-200 border-red-300 text-red-800',
      iconClass: 'text-red-700',
   },
   [GuideDifficulty.Difficult]: {
      icon: 'gauge-high',
      badgeClass: 'bg-red-100 border-red-300 text-red-700',
      iconClass: 'text-red-500',
   },
   [GuideDifficulty.Moderate]: {
      icon: 'gauge',
      badgeClass: 'bg-amber-100 border-amber-300 text-amber-700',
      iconClass: 'text-amber-500',
   },
   [GuideDifficulty.Easy]: {
      icon: 'gauge-low',
      badgeClass: 'bg-green-100 border-green-400 text-green-700',
      iconClass: 'text-green-500',
   },
   [GuideDifficulty.VeryEasy]: {
      icon: 'gauge-min',
      badgeClass: 'bg-green-200 border-green-400 text-green-800',
      iconClass: 'text-green-700',
   },
};

export function DifficultyBadge({
   difficulty,
   difficultyName,
   className,
}: {
   difficulty: GuideDifficulty;
   difficultyName: string;
   className?: string;
}) {
   return (
      <Tooltip>
         <TooltipTrigger asChild>
            <FlagBadge {...DifficultyThemeLookup[difficulty]} className={className}>
               {difficultyName}
            </FlagBadge>
         </TooltipTrigger>
         <TooltipContent className="text-sm">{DifficultyToolTipLookup[difficulty]}</TooltipContent>
      </Tooltip>
   );
}
